<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '#ui-kit/lib/utils'

const props = defineProps<{
  class?: HTMLAttributes['class']
}>()
</script>

<template>
  <kbd data-slot="kbd-group" :class="cn('inline-flex shrink-0 items-center gap-0.5', props.class)">
    <slot />
  </kbd>
</template>
